/**
 * Yotpo Custom Widget Enhancement
 * Appends an info icon with a custom static popup.
 * Initializes only after Yotpo has loaded and created the product-points wrapper.
 */
(function() {
  const CONFIG = {
    targetWrapperSelector: '.yotpo-product-points-inner-wrapper',
    triggerId: 'yotpo-custom-trigger',
    modalId: 'yotpo-custom-rewards-modal',
    maxWaitMs: 10000
  };

  let modalInitialized = false;

  function initModal() {
    if (modalInitialized) return;
    modalInitialized = true;

    const modal = document.getElementById(CONFIG.modalId);
    if (!modal) return null;

    document.body.appendChild(modal);

    const closeBtn = modal.querySelector('.yotpo-custom-close');
    const content = modal.querySelector('.yotpo-custom-modal-content');

    function toggleModal(show) {
      document.body.style.overflow = show ? 'hidden' : '';

      if (show) {
        modal.classList.remove('opacity-0', 'pointer-events-none');
        if (content) {
          content.classList.remove('scale-95');
          content.classList.add('scale-100');
        }
      } else {
        modal.classList.add('opacity-0', 'pointer-events-none');
        if (content) {
          content.classList.remove('scale-100');
          content.classList.add('scale-95');
        }
      }
    }

    modal.open = function() { toggleModal(true); };

    modal.addEventListener('click', function(e) {
      if (e.target === modal) toggleModal(false);
    });

    if (closeBtn) closeBtn.addEventListener('click', function() { toggleModal(false); });

    return modal;
  }

  function injectWidget(wrapper) {
    if (wrapper.querySelector('#' + CONFIG.triggerId)) return true;

    const triggerBtn = document.getElementById(CONFIG.triggerId);
    const modal = document.getElementById(CONFIG.modalId);

    if (!triggerBtn || !modal) return false;

    triggerBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (modal.open) modal.open();
    });

    wrapper.appendChild(triggerBtn);

    return true;
  }

  function ensureWidget() {
    const wrapper = document.querySelector(CONFIG.targetWrapperSelector);
    if (!wrapper) return false;

    initModal();
    return injectWidget(wrapper);
  }

  function init() {
    if (ensureWidget()) return;

    const observer = new MutationObserver(function() {
      ensureWidget();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(function() {
      observer.disconnect();
      ensureWidget();
    }, CONFIG.maxWaitMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();